import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from '@/router';
import { IUser } from '@/class/models/views/setting/users';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['ss3-loader'];

const VERSTION = process.env.VUE_APP_VERSTION;

declare module 'vue/types/vue' {
  interface Vue {
    $userData: IUser;
  }
}
Vue.prototype.$userData = {} as IUser;

// Bootstrap
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

// vuejs-pagenate
import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

// FontAwesome
import '@fortawesome/fontawesome-free/css/all.css';


// vue gtm
if (process.env.VUE_APP_MODE === 'PROD') {
  // tslint:disable-next-line:no-var-requires
  // const VueGtm = require(`../node_modules/vue-gtm/src/index.js`); // "vue-gtm": "^2.3.1"
  // console.log(VueGtm.default);
  Vue.use(VueGtm, {
    id: ['GTM-PZGPC3J'],
    queryParmas: [],
    enabled: true,
    debug: true,
  });
  // (this as any).$gtm.trackView('テストですけどきてます？', '/テストです');
}

// vue-meta
Vue.use(VueMeta);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
